"use client";

import { EventBySlugOutput } from "~/types/EventTypesInferred";
import { api } from "~/utils/api";

const useAttendee = (event: EventBySlugOutput, isRegistered?: boolean) => {
    const {
        data: attendee,
        isLoading: attendeeLoading,
        refetch: attendeeRefetch,
    } = api.attendee.getAttendeeByUserIdAndEventId.useQuery(event?.id, {
        enabled: isRegistered === true,
    });

    return { attendee, attendeeLoading, attendeeRefetch };
};

export default useAttendee;
